import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Popover,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CancelIcon from "@mui/icons-material/Cancel";

function SubjectList({
  subjectInfo,
  selectSubject,
  setSelectSubject,
  currentSubjectName,
  setCurrentSubjectName,
  currentSubjectInfo,
}) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSubject = (event) => {
    setAnchorEl(event.currentTarget);
    // setSelectSubject("");
  };

  const subjectChangeHandler = (event) => {
    const selectedId = event?.target?.value;
    setSelectSubject(selectedId);
  };

  const currentSwitch = (currentObj) => {
    setCurrentSubjectName({
      ...currentObj,
    });
  };

  useEffect(() => {
    setCurrentSubjectName({
      ...selectSubject,
    });
  }, []);

  const open = Boolean(anchorEl);
  const popoverId = open ? "simple-popover" : undefined;

  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: subjectInfo?.colourCode,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 6,
        }}
      >
        <Box>
          <button
            style={{
              display: "flex",
              width: "auto",
              alignItems: "center",
              borderRadius: "25px",
              cursor: "pointer",
              gap: 1,
              backgroundColor: "transparent",
              color: "inherit",
              boxShadow: "none",
              border: "none",
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
            onClick={handleSubject}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography
                sx={{
                  fontSize: "20px",
                  fontWeight: 700,
                  color: "#000",
                }}
              >
                {currentSubjectName?.name
                  ? currentSubjectName?.name
                  : currentSubjectInfo?.name}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <KeyboardArrowDownIcon sx={{ fontSize: "20px", color: "#000" }} />
            </Box>
          </button>

          <Popover
            id={popoverId}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            sx={{
              "& .MuiPopover-paper": {
                maxHeight: { md: "375px" },
                overflowY: "auto",
              },
            }}
          >
            <Box sx={{ width: "290px", pb: 1 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  pt: 2,
                  pl: 2,
                  pr: 2,
                }}
              >
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontWeight: 600,
                    color: "rgba(135, 149, 167, 1)",
                    fontSize: "12px",
                  }}
                >
                  SELECT SUBJECT
                </Typography>

                <button
                  style={{
                    borderRadius: "50%",
                    cursor: "pointer",
                    backgroundColor: "transparent",
                    color: "inherit",
                    boxShadow: "none",
                    border: "none",
                    padding: 0,
                    margin: 0,
                    width: "24px",
                    height: "24px",
                    "&:hover": {
                      backgroundColor: "transparent",
                    },
                    "&:focus": {
                      outline: "none",
                      backgroundColor: "transparent",
                      boxShadow: "none",
                    },
                  }}
                  onClick={handleClose}
                >
                  <CancelIcon
                    sx={{
                      cursor: "pointer",
                      color: "#747474",
                      "&:hover": {
                        color: "#343434",
                      },
                    }}
                  />
                </button>
              </Box>
              <Box sx={{ mt: 1, mb: 1, pl: 2, pr: 2 }}>
                <FormControl sx={{ width: "90%" }}>
                  <RadioGroup
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={selectSubject?.name}
                    onChange={subjectChangeHandler}
                  >
                    {subjectInfo?.length > 0 &&
                      subjectInfo?.map((subject) => (
                        <>
                          <FormControlLabel
                            key={subject}
                            value={subject?.id}
                            onClick={() => currentSwitch(subject)}
                            control={
                              <Radio
                                sx={{
                                  "&:hover": {
                                    bgcolor: "transparent",
                                  },
                                  "&.Mui-checked": {
                                    color: "transparent",
                                    "&::before": {
                                      content: '""',
                                      display: "block",
                                      width: "20px",
                                      height: "20px",
                                      borderRadius: "50%",
                                      backgroundColor: "white",
                                      border: "6px solid rgba(237, 94, 14, 1)",
                                      position: "absolute",
                                      top: "50%",
                                      left: "50%",
                                      transform: "translate(-50%, -50%)",
                                      zIndex: 1,
                                    },
                                  },
                                  position: "relative",
                                }}
                              />
                            }
                            label={
                              subject?.name?.charAt(0)?.toUpperCase() +
                              subject?.name?.slice(1)
                            }
                          />
                          <Box
                            sx={{
                              borderBottom: "1px solid rgba(244, 244, 244, 1)",
                              ml: 3,
                              mb: "5px",
                              mt: "5px",
                            }}
                          ></Box>
                        </>
                      ))}
                  </RadioGroup>
                </FormControl>
              </Box>
            </Box>
          </Popover>
        </Box>
      </Box>
      <Box
        sx={{
          width: "64px",
          height: "64px",
          position: "absolute",
          right: "40px",
          bottom: "-10px",
        }}
      >
        <img src={currentSubjectInfo?.image} alt="subject" width="100%" />
      </Box>
    </Box>
  );
}

export default SubjectList;
